import { render } from "./CreateEmailSettingPanel.vue?vue&type=template&id=2fe67c72&scoped=true"
import script from "./CreateEmailSettingPanel.vue?vue&type=script&lang=js"
export * from "./CreateEmailSettingPanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe67c72"]])

export default __exports__